export default function Ł(){ console.log('DEBUGLOG is disabled in production') };